import { render } from "./BotonExitosoEmbargoPersonaComponent.vue?vue&type=template&id=7303f68b"
import script from "./BotonExitosoEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./BotonExitosoEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__